import React from 'react'
import { useEffect, useState, useRef, createRef } from 'react';
import { useDispatch, useSelector } from "react-redux";
import { useLocation } from 'react-router-dom';
import ComFunction from "../components/ComFunction";
import AGFunction from "../components/AGFunction";
import MasterBase from "../components/MasterLayout";
import EntryGridAr from "../components/EntryGridAr";
import EntrySetting from "../components/EntrySetting";
import EntryRemarks from "../components/EntryRemarks";
import EntryImages from "../components/EntryImages";
import EntryFiles from "../components/EntryFiles";
import EntryBase from "../components/EntryBase";
import DropZone from "../components/DropZone";
import Box from '@material-ui/core/Box';
import Paper from '@material-ui/core/Paper';
import { isEmpty, Getstorage, Savestorage, DeepCopy, getWindowDimensions, setglobaldata, getglobaldata, getformid, getcontroller, getsubkey, initializedata, isEnabled, DicVal } from '../modules/appLibrary';
import { cfMargeUploadFiles } from '../modules/commodule';
import { setimagelist } from '../modules/imagedlgstore';
import { arrayMove } from 'react-sortable-hoc';
import { SortableContainer, SortableElement } from 'react-sortable-hoc';
import Chip from '@material-ui/core/Chip';
import { styled } from '@material-ui/core/styles';
import Icon from '@material-ui/core/Icon';
import IconButton from '@material-ui/core/IconButton';
import EntryLayout from '../components/EntryLayout';
import { changestatus, listtabs, entrytriggercall, setgridlist, listoption } from '../modules/formstore';
import { setentrypanel, addentrylayout, setentrylayout, setentrystartup } from '../modules/toolpanelstore';

const ListItem = styled('li')(({ theme }) => ({
    margin: theme.spacing(0.5),
    listStyle: 'none'
}));

export const BrdCdMst = props => {

    const panelsdef = [];
    const G_id = { BASE: "0", IMAGE: "pic", FILE: "file", NB: "nb", PL: "pl" };
    const formid = getformid("BrdCdMst", props.location.search);
    const controller = getcontroller("BrdCdMst", props.location.search);
    const subkey = getsubkey(props.location.search);

    const corpkey = useSelector(state => state.user.corpkey);
    const account = useSelector(state => state.user.account);
    const staff = useSelector(state => state.user.accctl);
    const menuinfo = useSelector(state => state.form.menuinfo);
    const mainlayout = useSelector(state => state.toolpnl.layouts_et);
    const mainprelayout = useSelector(state => state.toolpnl.prelayout_et);
    const maininitlayout = useSelector(state => state.toolpnl.initlayout_et);

    const AGRef = useRef();
    const fnc = useRef();
    const EntrybodyRef = useRef(null);
    const locationstate = useRef(null);

    const formstatus = useSelector(state => state.form.status);
    const entrylock = useSelector(state => state.form.entryformlock);
    const gridlist = useSelector(state => state.form.gridlist);
    const [panel, setpanel] = useState(panelsdef);
    const [windowDimensions, setWindowDimensions] = useState(getWindowDimensions());
    const [columninfo, setcolumninfo] = useState(null);
    const [columns, setcolumns] = useState(null);
    const [edittingcode, setedittingcode] = useState("");
    const [textfieldsall, settextfieldsall] = useState([]);
    const [textfields, settextfields] = useState([]);
    const [layoutlock, setlayoutlock] = useState(false);
    const [sectionclose, setsectionclose] = useState(false);
    const [update, setUpdate] = useState(false);
    const [isDragActive, setIsDragActive] = useState(false);

    const entrydataRef = useRef(null);
    const imageRef = useRef(null);
    const fileRef = useRef(null);
    const canEditKubunRef = useRef(false);
    const lockName1Ref = useRef(false);
    const formstatusRef = useRef(formstatus);
    const gridapiRefs = useRef([]);
    const gridcolapiRefs = useRef([]);
    const griddataRefs = useRef([]);
    const gridcolRefs = useRef([]);
    formstatusRef.current = formstatus;

    const dispatch = useDispatch();
    const search = useLocation().search;
    const AGFunc = React.forwardRef(AGFunction);
    const ComFunc = React.forwardRef(ComFunction);

    const actionurl = {
        "getlist": "BrdCdMst/GetListData",
    }

    const navmenu = [
        { status: "VIEW", menuid: "excel", icon: "file_download", label: "Excel", title: "現在のシート内容をExcelに出力します" },
    ]

    function SetGridData(panelInfo, data) {
        let gidx = fnc.current.gridindex(panelInfo);
        if (gidx === -1) return;
        griddataRefs.current[gidx].current = data;
    }
    function GridData(panelInfo) {
        let gidx = fnc.current.gridindex(panelInfo);
        if (gidx === -1) return null;
        return griddataRefs.current[gidx].current;
    }
    function SetGridColDef(panelInfo, coldef) {
        let gidx = fnc.current.gridindex(panelInfo);
        if (gidx === -1) return;
        gridcolRefs.current[gidx].current = coldef;
    }
    function SetGridApi(panelInfo, api) {
        let gidx = fnc.current.gridindex(panelInfo);
        if (gidx === -1) return;
        gridapiRefs.current[gidx].current = api;
    }
    function GridApi(panelInfo) {
        let gidx = fnc.current.gridindex(panelInfo);
        if (gidx === -1) return null;
        return gridapiRefs.current[gidx].current;
    }
    function SetGridColApi(panelInfo, api) {
        let gidx = fnc.current.gridindex(panelInfo);
        if (gidx === -1) return;
        gridcolapiRefs.current[gidx].current = api;
    }
    function GridColApi(panelInfo) {
        let gidx = fnc.current.gridindex(panelInfo);
        if (gidx === -1) return null;
        return gridcolapiRefs.current[gidx].current;
    }
    function rerender() {
        setUpdate(update ? false : true);
    }
    function ComposeCode(data, pushcode) {
        if (!isEmpty(pushcode)) return pushcode;
        if (isEmpty(data)) return "";
        let brdCode = DicVal(data, "BMEI_BRDCODE", "");
        let kubun = DicVal(data, "BMEI_KUBUN", "");
        let itemCode = DicVal(data, "BMEI_CODE", "");
        if (brdCode !== "" && kubun !== "" && itemCode !== "") return brdCode + "_" + kubun + "_" + itemCode;
        if (!isEmpty(data.code)) return data.code;
        return "";
    }
    function nametocolumn(name) {
        if (isEmpty(columninfo)) return "";
        if (!columninfo.some(e => e.columnid.indexOf(name) !== -1)) return "";
        return columninfo.find(e => e.columnid.indexOf(name) !== -1).columnid;
    }
    function ApplyEntryFieldLocks(targetColumns, targetColinfo, canEditKubun, lockName1) {
        let kubunLocked = !canEditKubun;
        if (!isEmpty(targetColinfo)) {
            for (let i = 0; i < targetColinfo.length; i++) {
                if (targetColinfo[i].columnid === "BMEI_KUBUN") targetColinfo[i].locked = kubunLocked;
                if (targetColinfo[i].columnid === "BMEI_NAME1") targetColinfo[i].locked = lockName1;
            }
        }
        if (!isEmpty(targetColumns)) {
            for (let i = 0; i < targetColumns.length; i++) {
                if (targetColumns[i].columnid === "BMEI_KUBUN") targetColumns[i].locked = kubunLocked;
                if (targetColumns[i].columnid === "BMEI_NAME1") targetColumns[i].locked = lockName1;
            }
        }
    }
    function ApplyListTabs(data) {
        setpanel(data.panels);
        dispatch(setentrypanel({
            layouts: data.layouts, prelayout: data.prelayout,
            initlayout: data.initlayout.length === 0 ? " " : data.initlayout,
            fitColumn: data.fitColumn
        }));
        setcolumninfo(data.colinfo);
        setcolumns(data.columns);
        let fields = data.colinfo.filter(e => e.logpid === G_id.BASE);
        settextfieldsall(fields);
        settextfields(data.columns.filter(e => e.logpid === G_id.BASE));
        fnc.current.initMaster(data.master);

        let idx = 0;
        let glist = [];
        data.panels.filter(e => e.grid).forEach(function (panelInfo) {
            gridapiRefs.current[idx] = createRef();
            gridcolapiRefs.current[idx] = createRef();
            griddataRefs.current[idx] = createRef();
            gridcolRefs.current[idx] = createRef();
            glist.push({ id: panelInfo.id, type: panelInfo.type, index: idx });
            idx++;
        });
        dispatch(setgridlist(glist));

        if (data.prelayout) RestoreLayout(data.panels, fields);

        let state = props.location.state;
        if (isEmpty(state) && !isEmpty(window.history.state) && "status" in window.history.state) state = window.history.state;
        locationstate.current = state;
        if (!isEmpty(state) && "code" in state) {
            clearform();
            dispatch(changestatus(state.code === "" ? "NEW FORM" : "ENTRY FORM"));
            if (data.panels.filter(e => e.grid).length === 0 && state.code !== "") {
                setedittingcode(state.code);
                LoadData(state.code);
                locationstate.current = null;
            }
        }
        fnc.current.wait(false);
    }

    useEffect(() => {
        if (isEmpty(corpkey) || isEmpty(account)) return;
        fnc.current.postaxios('common/GetListTabs', { "panels": panelsdef, "controller": controller, "subkey": subkey },
            {
                onSuccess: function (data) {
                    fnc.current.postaxios("BrdCdMst/GetKubunAuthority", null,
                        {
                            onSuccess: function (auth) {
                                canEditKubunRef.current = DicVal(auth.returnData, "canEditKubun", "0") === "1";
                                ApplyEntryFieldLocks(data.columns, data.colinfo, canEditKubunRef.current, formstatusRef.current === "COPY FORM" ? false : lockName1Ref.current);
                                ApplyListTabs(data);
                            },
                            onError: function (auth) {
                                canEditKubunRef.current = false;
                                ApplyEntryFieldLocks(data.columns, data.colinfo, false, formstatusRef.current === "COPY FORM" ? false : lockName1Ref.current);
                                ApplyListTabs(data);
                                fnc.current.warnmsg(isEmpty(auth.errDescription) ? "区分の権限判定に失敗したため、区分は読取専用で表示します。" : auth.errDescription + " 区分は読取専用で表示します。");
                            }
                        }, true
                    );
                }
            });
    }, [search]);

    useEffect(() => {
        function handleResize() {
            setWindowDimensions(getWindowDimensions());
        }
        window.addEventListener('resize', handleResize);
        return () => window.removeEventListener('resize', handleResize);
    }, []);

    useEffect(() => {
        if (isEmpty(menuinfo.ctrls)) return;
        setlayoutlock(menuinfo.ctrls.indexOf("LOCK2") !== -1);
        setsectionclose(menuinfo.ctrls.indexOf("SECCLOSE") !== -1);
    }, [menuinfo]);

    useEffect(() => {
        if (isEmpty(columninfo)) return;
        let newcolinfo = DeepCopy(columninfo);
        let newcolumns = DeepCopy(columns);
        let newfieldsall = DeepCopy(textfieldsall);
        let newfields = DeepCopy(textfields);
        let lockName1 = formstatus === "COPY FORM" ? false : lockName1Ref.current;
        ApplyEntryFieldLocks(newcolumns, newcolinfo, canEditKubunRef.current, lockName1);
        ApplyEntryFieldLocks(newfields, newfieldsall, canEditKubunRef.current, lockName1);
        setcolumninfo(newcolinfo);
        setcolumns(newcolumns);
        settextfieldsall(newfieldsall);
        settextfields(newfields);
    }, [formstatus]);

    function onFirstDataRendered(param, panelInfo) {
        SetGridApi(panelInfo, param.api);
        SetGridColApi(panelInfo, param.api);
        if (!isEmpty(locationstate.current)) {
            let call = true;
            for (let i = 0; i < gridlist.length; i++) {
                if (EmptyPanel(gridlist[i].id, gridlist[i].type)) continue;
                if (isEmpty(GridApi(gridlist[i]))) {
                    call = false;
                    break;
                }
            }
            if (call && locationstate.current.code !== "") Show(undefined, locationstate.current.code);
            if (call) locationstate.current = null;
        }
    }
    function Show(data, pushcode) {
        let code = ComposeCode(data, pushcode);
        if (!isEmpty(data)) setglobaldata("entryrowdata", data);
        setedittingcode(code);
        if (isEmpty(columninfo)) return false;
        clearform(code === "");
        if (code !== "") LoadData(code);
        return true;
    }
    function SetLayout(newcol, type) {
        let newfields = DeepCopy(textfields.filter(e => e.type !== type));
        for (let i = 0; i < newcol.length; i++) {
            let column = textfieldsall.find(e => e.columnid === newcol[i]);
            newfields.push(column);
        }
        settextfields(newfields);
    }
    function showpanel(id, type, show) {
        let newpanel = DeepCopy(panel);
        let target = newpanel.find(e => e.id === id && e.type === type);
        target.hide = !show;
        setpanel(newpanel);
    }
    function storeRowData(panelInfo) {
        if (panelInfo === undefined) {
            for (let i = 0; i < gridlist.length; i++) SetGridData(gridlist[i], AGRef.current.GetDatasource(GridApi(gridlist[i])));
            return;
        }
        SetGridData(panelInfo, AGRef.current.GetDatasource(GridApi(panelInfo)));
    }
    function Jump(id, type) {
        let panelid = "basepanel" + type;
        if (id === G_id.IMAGE) panelid = 'imagepanel';
        if (id === G_id.FILE) panelid = 'fileGrid';
        if (id === G_id.NB) panelid = 'remarkspanel' + type;
        if (isEmpty(type)) type = tabletype(id);
        if (panel.some(e => e.id === id && e.type === type && e.grid)) panelid = fnc.current.GridID({ id: id, type: type });
        let elem = document.getElementById(panelid);
        if (isEmpty(elem)) return;
        EntrybodyRef.current.scrollTop = elem.offsetTop - 50;
    }
    function MenuAction(action, finallycallback) {
        LayoutSaveStorage();
        if (action === 'save') Save(finallycallback);
        if (action === 'delete') Delete(finallycallback);
        if (action === "clear") clearform(true);
        if (action === 'linkfield') {
            let col = textfields.find(e => e.columnid === finallycallback.field && (isEmpty(finallycallback.type) ? true : e.type === finallycallback.type));
            if (col === undefined) return;
            if (col.logpid === "0") {
                let key = finallycallback.field + "_" + col.type;
                document.getElementById(key).focus();
                document.getElementById(key).select();
                Jump(G_id.BASE, col.type);
                return;
            }
            Jump(col.logpid);
            AGRef.current.SetRowSelect(finallycallback.rowid, finallycallback.field, GridApi({ id: col.logpid }));
        }
    }
    function Save(finallycallback, nocheck) {
        storeRowData();
        SetPLData();
        let detail = {};
        for (let i = 0; i < gridlist.length; i++) {
            if (gridlist[i].id === G_id.PL) continue;
            detail[gridlist[i].type] = GridData(gridlist[i]);
        }
        const paramdata = {
            "controller": controller,
            "data": entrydataRef.current,
            "detail": detail,
            "images": imageRef.current,
            "files": fileRef.current,
            "colinfo": columninfo,
            "code": edittingcode,
            "noconfirm": nocheck
        }
        fnc.current.postaxios(formstatus === "ENTRY FORM" ? "BrdCdMst/UpdateEntry" : "BrdCdMst/InsertEntry", paramdata,
            {
                onSuccess: function (data) {
                    if (data.warning.length === 0) {
                        fnc.current.modify(false);
                        let requestCode = isEmpty(data.request) ? ComposeCode(entrydataRef.current, edittingcode) : data.request;
                        setedittingcode(requestCode);
                        if (formstatus !== "ENTRY FORM") dispatch(changestatus("ENTRY FORM"));
                        fnc.current.success();
                    } else if (isEnabled(data.confirm)) {
                        let msgs = ["内容を確認しそのまま登録する場合はOK,修正する場合はCancelを選択してください", "　"];
                        for (let i = 0; i < data.warning.length; i++) msgs.push("・" + data.warning[i].message);
                        fnc.current.confmsg(msgs, () => Save(finallycallback, true));
                    } else {
                        fnc.current.showwarndescription(data.warning.length + "件の制約違反により登録できませんでした。", data.warning);
                    }
                    fnc.current.wait(false);
                },
                errmsg: "登録に失敗しました"
            }
        )
    }
    function Delete(finallycallback) {
        const param = {
            "controller": controller,
            "data": entrydataRef.current,
            "colinfo": columninfo,
            "code": edittingcode
        }
        fnc.current.postaxios("BrdCdMst/Delete", param,
            {
                onSuccess: function (data) {
                    if (data.warning.length === 0) {
                        fnc.current.success();
                        finallycallback("", []);
                    } else {
                        fnc.current.warnmsg(["このデータは削除できません", data.warning[0].message]);
                    }
                    fnc.current.wait(false);
                },
                errmsg: "削除に失敗しました"
            }
        )
    }
    function LoadData(code) {
        if (code === "") return;
        fnc.current.postaxios('BrdCdMst/GetData', { "code": code, "colinfo": columninfo, "controller": controller },
            {
                onSuccess: function (data) {
                    try {
                        let row = getglobaldata("entryrowdata");
                        if (!isEmpty(row)) {
                            let memo = nametocolumn("_memo");
                            if (memo !== "" && memo in row) data.data[memo] = row[memo];
                            let sticky = nametocolumn("_sticky");
                            if (sticky !== "" && sticky in row) data.data[sticky] = row[sticky];
                            let mytags = nametocolumn("_mytags");
                            if (mytags !== "" && mytags in row) data.data[mytags] = row[mytags];
                        }
                        fnc.current.margeMaster(data.master);
                        entrydataRef.current = data.data;
                        imageRef.current = data.images;
                        fileRef.current = data.files;
                        lockName1Ref.current = DicVal(data.returnData, "lockName1", "0") === "1";
                        let newcolinfo = DeepCopy(columninfo);
                        let newcolumns = DeepCopy(columns);
                        let newfieldsall = DeepCopy(textfieldsall);
                        let newfields = DeepCopy(textfields);
                        ApplyEntryFieldLocks(newcolumns, newcolinfo, canEditKubunRef.current, formstatusRef.current === "COPY FORM" ? false : lockName1Ref.current);
                        ApplyEntryFieldLocks(newfields, newfieldsall, canEditKubunRef.current, formstatusRef.current === "COPY FORM" ? false : lockName1Ref.current);
                        setcolumninfo(newcolinfo);
                        setcolumns(newcolumns);
                        settextfieldsall(newfieldsall);
                        settextfields(newfields);
                        dispatch(setimagelist(data.images));
                        rerender();
                        fnc.current.wait(false);
                    } catch (error) {
                        console.log(error);
                        fnc.current.wait(false);
                    }
                },
                onError: function (data) {
                    fnc.current.warnmsg(isEmpty(data.errDescription) ? "処理に失敗しました" : data.errDescription);
                    dispatch(changestatus("VIEW"));
                    fnc.current.wait(false);
                }
            }
        )
    }
    function SetPLData() {
        gridlist.filter(e => e.id === G_id.PL).forEach(function (list) {
            let column = columninfo.find(e => e.type === list.type);
            if (!isEmpty(column)) entrydataRef.current[column.columnid] = fnc.current.PLTextData(GridData(list), column.columnid);
        });
    }
    function clearform(newform) {
        lockName1Ref.current = false;
        entrydataRef.current = initializedata(textfieldsall, staff);
        imageRef.current = null;
        fileRef.current = null;
        let newcolinfo = DeepCopy(columninfo);
        let newcolumns = DeepCopy(columns);
        let newfieldsall = DeepCopy(textfieldsall);
        let newfields = DeepCopy(textfields);
        ApplyEntryFieldLocks(newcolumns, newcolinfo, canEditKubunRef.current, false);
        ApplyEntryFieldLocks(newfields, newfieldsall, canEditKubunRef.current, false);
        setcolumninfo(newcolinfo);
        setcolumns(newcolumns);
        settextfieldsall(newfieldsall);
        settextfields(newfields);
        for (let i = 0; i < gridlist.length; i++) SetGridData(gridlist[i], null);
        dispatch(setimagelist([]));
        fnc.current.modify(false);
        if (isEnabled(newform)) {
            fnc.current.postaxios("common/GetInitSqlValue", { colinfo: textfieldsall },
                {
                    onSuccess: function (data) {
                        for (let key in data.returnData) {
                            let col = textfieldsall.find(e => e.columnid === key);
                            if (!isEmpty(col)) col.initvalue = data.returnData[key];
                        }
                        entrydataRef.current = initializedata(textfieldsall, staff);
                        rerender();
                    },
                }, true
            )
        }
    }
    function RestoreLayout(panels, fields) {
        RestorePanel(panels);
        RestoreBase(fields);
    }
    function RestorePanel(panelData) {
        let saved = Getstorage(corpkey, account, formid + "panel");
        if (isEmpty(saved) || panelData.length !== saved.length) return;
        for (let i = 0; i < saved.length; i++) {
            let item = panelData.find(e => e.id === saved[i].id && e.type === saved[i].type);
            if (isEmpty(item)) return;
            saved[i].name = item.name;
            saved[i].name2 = item.name2;
            saved[i].abbr = item.abbr;
        }
        setpanel(saved);
    }
    function RestoreBase(fields) {
        const baseinfo = Getstorage(corpkey, account, fnc.current.statusKey(G_id.BASE, "", formid));
        if (isEmpty(baseinfo)) return;
        let newdata = [];
        for (let i = 0; i < baseinfo.length; i++) {
            let item = fields.find(e => e.table === baseinfo[i].table && e.columnid === baseinfo[i].columnid);
            if (isEmpty(item)) return;
            newdata.push(item);
        }
        settextfields(newdata);
    }
    function LayoutSaveStorage() {
        for (let i = 0; i < gridlist.length; i++) {
            AGRef.current.SaveColState(fnc.current.statusKey(gridlist[i].id, gridlist[i].type, formid), EmptyPanel(gridlist[i].id, gridlist[i].type) ? null : GridColApi(gridlist[i]));
        }
        Savestorage(corpkey, account, fnc.current.statusKey(G_id.BASE, "", formid), textfields);
        Savestorage(corpkey, account, formid + "panel", panel);
    }
    function SaveLayout(layoutid) {
        let setbase = false;
        let coldef = [];
        for (let p = 0; p < panel.length; p++) {
            let cols = [];
            if (panel[p].id === G_id.BASE) {
                if (setbase) break;
                let fields = textfields.filter(x => !x.hide);
                for (let f = 0; f < fields.length; f++) {
                    coldef.push({
                        headerName: fields[f].columnnm, table: fields[f].table, field: fields[f].columnid, width: fields[f].width,
                        type: fields[f].type
                    });
                }
                setbase = true;
            } else {
                cols = AGRef.current.GetshownColDef(GridColApi({ id: panel[p].id, type: panel[p].type }));
            }
            for (let i = 0; i < cols.length; i++) {
                let col = DeepCopy(cols[i]);
                col.type = tabletype(panel[p].id);
                coldef.push(col);
            }
        }
        fnc.current.postaxios('common/SaveLayout',
            {
                controller: controller,
                subkey: subkey,
                code: layoutid,
                coldef: coldef,
                panels: panel
            },
            {
                onSuccess: function () {
                    dispatch(addentrylayout({ value: layoutid, label: layoutid }));
                    fnc.current.success();
                    fnc.current.wait(false);
                },
            }
        )
    }
    function DeleteLayout(layoutid) {
        fnc.current.postaxios('common/DeleteEntryLayout',
            {
                controller: controller,
                subkey: subkey,
                code: layoutid,
            },
            {
                onSuccess: function (data) {
                    dispatch(setentrylayout(mainlayout.filter(val => val.value !== layoutid)));
                    if (data.request !== maininitlayout) {
                        dispatch(setentrystartup({
                            prelayout: mainprelayout,
                            initlayout: " ",
                            fitColumn: false
                        }));
                    }
                    fnc.current.success();
                    fnc.current.wait(false);
                },
            }
        )
    }
    function CallLayout(layoutid) {
        fnc.current.postaxios('common/LoadLayout',
            {
                controller: controller,
                subkey: subkey,
                code: layoutid,
            },
            {
                onSuccess: function (data) {
                    ApplyEntryFieldLocks(data.columns, null, canEditKubunRef.current, formstatusRef.current === "COPY FORM" ? false : lockName1Ref.current);
                    for (let i = 0; i < gridlist.length; i++) {
                        let type = gridlist[i].type;
                        let coldef = AGRef.current.createColDef(columninfo.filter(e => e.type === type), data.columns.filter(e => e.type === type), false);
                        if (coldef.length === 0) continue;
                        SetGridColDef({ id: gridlist[i].id, type: gridlist[i].type }, coldef);
                    }
                    setpanel(data.panels);
                    settextfields(data.columns.filter(e => e.logpid === G_id.BASE));
                    setcolumns(data.columns);
                    fnc.current.wait(false);
                },
            }
        )
    }
    function tabletype(id) {
        let target = panel.find(e => e.id === id);
        if (isEmpty(target)) return '';
        return target.type;
    }
    function fileuploaded(data) {
        let duplicate = false;
        if (formstatus === 'NEW FORM' || formstatus === 'COPY FORM') {
            if (cfMargeUploadFiles(imageRef, data.images)) duplicate = true;
            if (cfMargeUploadFiles(fileRef, data.files)) duplicate = true;
        } else {
            imageRef.current = data.images;
            fileRef.current = data.files;
        }
        dispatch(setimagelist(imageRef.current));
        rerender();
        if (duplicate) fnc.current.warnmsg("同名のファイルが存在しました。差し替える場合は元のファイルを削除してからアップロードしてください");
    }
    function ValueChanged(id) {
        let col = columninfo.find(e => e.columnid === id);
        if (!isEmpty(col) && col.extriggerref) dispatch(entrytriggercall(id));
    }
    function onDragEnter(e) {
        if (entrylock) return;
        if (e.dataTransfer.items && e.dataTransfer.items.length > 0) setIsDragActive(true);
    }
    const onPanelSortEnd = ({ oldIndex, newIndex }) => {
        let items = panel.filter(e => !panelhidden(e));
        let oldidx = panel.findIndex(e => e.type === items[oldIndex].type);
        let newidx = panel.findIndex(e => e.type === items[newIndex].type);
        setpanel(arrayMove(panel, oldidx, newidx));
    };
    const SortablePanelItem = SortableElement(({ pnl }) => (
        <ListItem className="minwidth0">
            <Chip label={pnl.name} title={pnl.name} size="small" onClick={() => Jump(pnl.id, pnl.type)} />
        </ListItem>
    ));
    const SortablePanelSelector = SortableContainer(({ items }) => {
        let newitem = [];
        for (let i = 0; i < items.length; i++) if (!panelhidden(items[i])) newitem.push(items[i]);
        return (
            <ul style={{ display: 'flex' }}>
                {newitem.map((value, index) => <SortablePanelItem key={`item-${index}`} index={index} pnl={value} />)}
            </ul>
        );
    });
    function Contents(props) {
        if (props.panel.id === G_id.BASE) {
            return (
                <div id={"basepanel" + props.panel.type}>
                    <EntryBase
                        fnc={fnc}
                        textfields={textfields}
                        settextfields={settextfields}
                        panel={props.panel}
                        ValueChanged={ValueChanged}
                        entrydataRef={entrydataRef}
                        layoutlock={layoutlock}
                    />
                </div>
            );
        }
        if (props.panel.id === G_id.IMAGE) return <EntryImages fnc={fnc} controller={controller} code={edittingcode} dataRef={imageRef} rerender={rerender} />;
        if (props.panel.grid) {
            return (
                <EntryGridAr
                    id={fnc.current.GridID(props.panel)}
                    entrydataRef={entrydataRef}
                    dataRef={griddataRefs.current[fnc.current.gridindex(props.panel)]}
                    columnRef={gridcolRefs.current[fnc.current.gridindex(props.panel)]}
                    columninfo={columninfo}
                    columns={columns}
                    fnc={fnc}
                    onFirstDataRendered={onFirstDataRendered}
                    formid={formid}
                    ValueChanged={() => storeRowData(props.panel)}
                    panel={props.panel}
                />
            );
        }
        if (props.panel.id === G_id.FILE) return <EntryFiles fnc={fnc} controller={controller} code={edittingcode} dataRef={fileRef} rerender={rerender} />;
        if (props.panel.id === G_id.NB) {
            if (isEmpty(columninfo)) return null;
            let coldef = columninfo.find(e => e.type === props.panel.type);
            return <EntryRemarks id={"remarkspanel" + props.panel.type} def={coldef} dataRef={entrydataRef} fnc={fnc} ValueChanged={ValueChanged} />;
        }
        return null;
    }
    function EmptyPanel(id, type) {
        try {
            if (!panel.some(e => e.id === id)) return true;
            if (!isEmpty(type) && !panel.some(e => e.id === id && e.type === type)) return true;
            if (id === G_id.BASE) return isEmpty(textfields.find(e => e.type === type));
            return !columns.some(e => e.type === tabletype(id));
        } catch {
        }
        return false;
    }
    function panelhidden(p) {
        if (isEmpty(p)) return false;
        if (p.id === G_id.IMAGE) {
            if (isEmpty(imageRef.current) || imageRef.current.length === 0) return true;
            return p.hide;
        }
        if (p.id === G_id.FILE) {
            if (isEmpty(fileRef.current) || fileRef.current.length === 0) return true;
            return p.hide;
        }
        if (EmptyPanel(p.id, p.type)) return true;
        return p.hide;
    }
    function EntryForm() {
        return (
            <div style={{ padding: '5px 15px', paddingBottom: '300px', height: '100%', overflow: 'auto', backgroundColor: '#D8D8D8' }} ref={EntrybodyRef} onDragEnter={onDragEnter}>
                {panel.map((p, i) => (
                    <Box key={i} display={panelhidden(p) ? "none" : "flex"} justifyContent="space-around" alignItems="center" padding="5px">
                        <Paper style={{ width: '100%', height: 'auto', padding: 10 }}>
                            <div style={{ position: 'relative', marginBottom: 5 }}>
                                {p.name} - <span style={{ fontStyle: 'oblique' }}>{p.name2}</span>
                                {p.id !== '0' || layoutlock ? null :
                                    <div style={{ position: 'absolute', right: 40, top: -3 }} title="項目設定">
                                        <IconButton size="small" onClick={() => fnc.current.entrylayoutopen(p.type)}><Icon style={{ fontSize: 16 }}>settings_applications</Icon></IconButton>
                                    </div>}
                                {layoutlock || sectionclose ? null :
                                    <div style={{ position: 'absolute', right: 10, top: -3 }}>
                                        <IconButton size="small" onClick={() => showpanel(p.id, p.type, false)}><Icon style={{ fontSize: 16 }}>close</Icon></IconButton>
                                    </div>}
                            </div>
                            <Contents panel={p} />
                        </Paper>
                    </Box>
                ))}
            </div>
        );
    }

    return (
        <div>
            <ComFunc ref={fnc} />
            <MasterBase
                formid={formid}
                controller={controller}
                subkey={subkey}
                location={props.location}
                actionurl={actionurl}
                uploaded={fileuploaded}
                entrycallback={MenuAction}
                condition={true}
                entryform={true}
                tabs={true}
                show={Show}
                primarykey={["rowid"]}
                navmenu={navmenu}
                entrydataRef={entrydataRef}
                usecondition={true}
            >
                <EntryForm />
            </MasterBase>
            <EntryLayout columninfo={textfieldsall} textfields={textfields} onAppry={SetLayout} />
            {formstatus === 'NEW FORM' || formstatus === 'ENTRY FORM' || formstatus === 'COPY FORM' ?
                <div>
                    <div style={{ position: 'absolute', top: 60, right: 15 }}>
                        <IconButton size="small" onClick={() => fnc.current.entrysettingopen()} title={"レイアウト設定"}><Icon>table_chart</Icon></IconButton>
                    </div>
                    <div style={{ position: 'absolute', top: 60, left: 210 }}>
                        <Paper
                            sx={{ display: 'flex', justifyContent: 'center', flexWrap: 'wrap', listStyle: 'none', p: 0.5, m: 0 }}
                            component="ul"
                            elevation={0}
                            style={{ backgroundColor: "transparent", width: windowDimensions.width - 280 }}
                        >
                            <SortablePanelSelector axis={"x"} items={panel} onSortEnd={onPanelSortEnd} distance={2} />
                        </Paper>
                    </div>
                </div>
                : null}
            <AGFunc ref={AGRef} />
            <EntrySetting
                formid={formid}
                controller={controller}
                subkey={subkey}
                savelayout={SaveLayout}
                deletelayout={DeleteLayout}
                calllayout={CallLayout}
                panels={panel}
                showpanel={showpanel}
            />
            <DropZone controller={controller} code={edittingcode} open={isDragActive} onclose={() => setIsDragActive(false)} actionurl={actionurl} uploaded={fileuploaded} />
        </div>
    );
};
